<template>
  <div>
    <l-map
      id="map1"
      ref="map"
      class="input-map"
      :zoom="zoom"
      :center="center"
      :bounds="bounds"
      :options="mapOptions"
    >
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <!-- Grenze Dachau Json -->
      <l-geo-json ref="dachauGrenze" :geojson="dachauGrenze" :options="dachauGrenzeOptions"></l-geo-json>
      <!-- Marker -->
      <Cluster :options="clusterOptions">
        <l-geo-json :geojson="markers" :options="markersOptions">
          <!-- <l-popup ref="popup" class="popup">
          <div class="popup-header">
            <span>
              <strong>{{ "user" }}</strong>
            </span>
            <span>{{"date"}}</span>
          </div>
          <div class="popup-main">
            <span>{{ "hello" }}</span>
          </div>
          </l-popup>-->
        </l-geo-json>
      </Cluster>
      <!-- Neuer Marker -->
      <l-marker
        v-if="newMarker"
        :key="newMarker.id"
        :lat-lng="[newMarker.coords.lat, newMarker.coords.lng]"
        :icon="newMarker.icon"
        @add="openPopup"
      >
        <l-popup style="width: 200px;" ref="popup" class="popup">
          <div class="popup-header">
            <!-- <span>{{ newMarker.name.toUpperCase() }}</span> -->
          </div>
          <div class="popup-main">
            <textarea placeholder="Geben Sie hier Ihren Text ein." v-model="text"></textarea>
          </div>
          <div class="popup-buttons">
            <button class="cancel" @click="cancel">abbrechen</button>
            <button class="submit" @click="createMarker">absenden</button>
          </div>
        </l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LGeoJson,
  LPopup,
  PopupContent
} from "vue2-leaflet";
import axios from "axios";
import { default as dachauGrenze } from "../../assets/geojson/dachau-geojson.js";
import * as L from "leaflet";
import Cluster from "vue2-leaflet-markercluster";
import * as Cookies from "js-cookie";
import { mapState } from "vuex";
import markers from "@/assets/geojson/original/markers.js";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LGeoJson,
    LPopup,
    Cluster
  },
  data() {
    return {
      // apiUrl:
      //   process.env.NODE_ENV == "development"
      //     ? "http://localhost:3000"
      //     : "https://dachaudenktweiter.de/api",
      apiUrl: "https://dachaudenktweiter.de/api",
      text: null,
      mapOptions: {
        // scrollWheelZoom: false,
        doubleClickZoom: false
      },
      maxZoom: 13,
      zoom: 13,
      center: [48.266132, 13.442426],
      bounds: L.latLngBounds(L.geoJson(dachauGrenze).getBounds()),
      url: "https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png",
      attribution: `
      &copy; <a target="blank" href="http://www.openstreetmap.org/copyright">OpenStreetMap-Mitwirkende</a>
      `,

      newMarker: null,
      // Hintergrund Layer Dachau Grenze
      dachauGrenze: dachauGrenze,
      dachauGrenzeOptions: {
        fillColor: "grey",
        fillOpacity: 0.2,
        strokeColor: "grey",
        opacity: 1,
        color: "grey",
        weight: 2
      },
      // Alle Marker
      geojsons: [],
      markers: markers,
      edit: false,
      submitDelete: false,
      clusterOptions: {
        // disableClusteringAtZoom: 15
      },
      markersOptions: {
        weight: 1,
        fillOpacity: 0.8,
        opacity: 1,
        color: "white",
        icon: L.icon({
          iconUrl: require("../../assets/icons/" + "haus" + ".gif"),
          iconSize: ["auto", 30],
          iconAnchor: [10, 10],
          popupAnchor: [5, 0]
        }),
        onEachFeature: (feature, layer) => {
          layer.setIcon(
            new L.Icon({
              iconUrl: require("../../assets/icons/" +
                feature.properties.kategorie +
                ".gif"),
              iconSize: ["auto", 30],
              iconAnchor: [10, 10],
              popupAnchor: [5, 0]
            })
          );
          layer.bindPopup(`
            <div class="popup-header">
              <span>
                <strong>${feature.properties.benutzer}</strong>
              </span>
            </div>
            <div class="popup-main">
              <span>${feature.properties.beitrag}</span>
            </div>
          `);
        }
      }
    };
  },
  computed: {},
  methods: {
    // Aktuelles Datum generieren
    getDate(date) {
      let array = date.slice(0, 10).split("-");
      let year = array[0];
      let month = array[1];
      let day = array[2];
      return day + "/" + month + "/" + year;
    }
  }
};
</script>
<style lang="scss">
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
.input-map {
  width: 100% !important;
}

#map1 {
  width: 100%;
  height: 500px;
}

.leaflet-popup-content {
  display: flex;
  flex-direction: column;
  margin: 10px;
}
.popup-header {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 5px;
}
.popup-main {
  background: #ebebeb;
  padding: 5px;
  overflow-y: scroll;
  width: 200px;
  max-height: 10rem;
}
@media (min-width: 768px) {
  .vue2leaflet-map {
    width: 100%;
  }
  .leaflet-popup-content {
    font-size: 0.9rem;
  }
  .popup-main {
    padding: 10px;
    width: 350px;
  }
}
</style>